export default __webpack_public_path__ + "static/media/placeMarker.72077354.svg";